module.exports = __webpack_public_path__ + "img/faq_mens.1bfe325f.jpg";